export const environment = {
  appVersion: require('../../package.json').version + '-prod',
  production: true
};

